import {Injectable} from "@angular/core";
import {RequesterService} from "../../../../shared/services/requester/requester.service";
import * as fromStore from "../../../../store";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../../../store";
import {combineLatest} from "rxjs";
import {Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import {Config} from "../../../../config/config";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {BehaviorSubject} from "rxjs";
import mockData from "../../../../../assets/json/mock-data.json";

@Injectable()
export class EcommerceSettingsService {
  private _ownerWorkspaceId: number;
  private _currentWorkspaceId: number;

  constructor(private _requester: RequesterService,
              private _httpClient: HttpClient,
              private _store: Store<DbStoreState>) {
    this._getWorkspaceEntities();
  }

  getSettings(domainID: number): Observable<any> {
    if (domainID === Config.demoDomainId) {
      const response: any = mockData['settings'];
      return new BehaviorSubject<DbResponse>(response);
    }
    return this._requester.tenWebWoocom
      .get(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=settings`, true);
  }

  updateSettings(domainID: number, data): Observable<any> {
    return this._requester.tenWebWoocom
      .post(`workspaces/${this._currentWorkspaceId}/domains/${domainID}?endpoint=settings`, null, data);
  }

  private _getWorkspaceEntities(): void {
    combineLatest(
      this._store.select(fromStore.getUserSubscription),
      this._store.select(fromStore.getWorkspaceIdEntities)
    ).subscribe(([userSubscription, workspaceIdEntities]) => {
      this._ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this._currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this._ownerWorkspaceId;
    });
  }

}
